/* global grecaptcha */
function initializeReCaptcha(locale) {
    // Pokud nejsou načtené knihovny jQuery nebo nette, vypíšeme chybu a ukončíme
    if (!$ || typeof $.nette === 'undefined') {
        console.error('nette.ajax.js library is required, please load it.');
        return;
    }

    let callbackName = 'g_onRecaptchaLoad_' + Date.now();

    // Funkce pro renderování všech reCaptcha elementů
    let renderAll = function () {
        $('.g-recaptcha').each(function () {
            let el = $(this);
            if (el.children().length) { // již renderováno
                return;
            }
            grecaptcha.render(this, {}, true);
        });
    };

    // Nastavíme globální callback, který zavoláme při načtení API
    window[callbackName] = function () {
        renderAll();

        $.nette.ext('recaptcha', {
            load: function () {
                renderAll();
            }
        });
    };

    // Načteme API se správným onload callbackem a jazykem
    $('<script />', {
        src: 'https://www.google.com/recaptcha/api.js'
            + '?onload=' + callbackName
            + '&render=explicit'
            + '&hl=' + (locale || $('html').attr('lang') || 'en')
    }).appendTo('head');
}
window.initializeReCaptcha = initializeReCaptcha;